export const setNotificationTypes = (state, data) => {
    state.notificationTypes = data;
};

export const setFcmDevices = (state, data) => {
    state.fcmDevices = data;
};
